<template>
    <div class="location">
        <img src="@/assets/img/weizhi.png" width="21" style="transform: translateY(1px);" alt="">
        <span class="location-label">当前位置：</span>
        <router-link class="location-nav" to="/">首页</router-link>
        <span class="location-nav-next">/</span>
        <div
            v-for="(item,i) of data"
            :key="i"
            style="display:inline;"
        >
            <router-link class="location-nav" :to="item.path" v-if="item.path">{{ item.title }}</router-link>
            <span v-else>{{ item.title }}</span>
            <span class="location-nav-next" v-if="i != data.length-1">/</span>
        </div>
        <!-- <a class="location-nav" href="javascript:;">{{ classifyName }}</a> -->
    </div>
</template>
<script>
    import {
        autoRow, 
        autoCol
    } from "@/components"
    export default {
        name: '',
        components: {
            autoRow, 
            autoCol
        },
        props: {
            data:{
                type:Array,
                default:[],
            }
        },
        data() {
            return {
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
//        beforeMount(){}, //模板编译/挂载之前
       mounted(){
       }, //模板编译/挂载之后(不保证组件已在document中)
       beforeUpdate(){
       }, //组件更新之前
       updated(){
       }, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.location{
    padding:25px 20px;
    font-size:18px;
}
.location-label{
    margin-left:10px;
    margin-right:10px;
}
.location-nav-next{
    margin:0 10px;
}
.location-nav:hover{
    color:#1BB3F0;
}
.location-nav:last-child{
    color:#1BB3F0;
}
</style>
